module.exports = __webpack_public_path__ + "static/img/third-top.5521a33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/1yuan365new/send/third-top.png
// module id = mt+/
// module chunks = 0